<template>
	<div style="width: 100%" :class="className">
		<div class="title">
			<h2>WORKSPACE</h2>
		</div>
		<div class="main">
			<div class="left">
				<div class="container md-elevation-2">
					<div>
						<div style="display: flex">
							<el-button @click="addNode">Add folder</el-button>
							<el-button @click="addLeaf">Add file</el-button>
						</div>
						<vue-tree-list
							@click="onClick"
							@change-name="onChangeName"
							@delete-node="onDel"
							@add-node="onAddNode"
							:model="data"
							default-tree-node-name="new node"
							default-leaf-node-name="new leaf"
							v-bind:default-expanded="false"
						>
							<template v-slot:leafNameDisplay="slotProps">
								<span>{{ slotProps.model.name }}</span>
							</template>
							<!--<span class="icon" slot="addTreeNodeIcon">📂</span>
              <span class="icon" slot="addLeafNodeIcon">＋</span>
              <span class="icon" slot="editNodeIcon">📃</span>
              <span class="icon" slot="delNodeIcon">✂️</span>
              <span class="icon" slot="leafNodeIcon">🍃</span>
              <span class="icon" slot="treeNodeIcon">📂</span>-->
							<i class="el-icon-folder" slot="treeNodeIcon" style="margin-right: 5px"></i>
							<i class="el-icon-document" style="margin-right: 5px" slot="leafNodeIcon"></i>
							<i class="el-icon-folder-add" slot="addTreeNodeIcon"></i>
							<i class="el-icon-document-add" slot="addLeafNodeIcon"></i>
							<i class="el-icon-edit" slot="editNodeIcon"></i>
							<i class="el-icon-delete" slot="delNodeIcon"></i>
						</vue-tree-list>
					</div>
				</div>
				<div class="container md-elevation-2" style="margin-top: 50px">CA</div>
			</div>
			<div class="right">
				<div class="container md-elevation-2">workspace</div>
			</div>
			<el-button class="fab" circle>
				<md-icon>add</md-icon>
			</el-button>
		</div>
	</div>
</template>

<script>
import { VueTreeList, Tree, TreeNode } from "vue-tree-list"
export default {
	name: "Home",
	props: ["className"],
	components: {
		VueTreeList
	},
	data() {
		return {
			newTree: {},
			data: new Tree([
				{
					name: "Node 1",
					id: 1,
					pid: 0,
					dragDisabled: true,
					addTreeNodeDisabled: true,
					addLeafNodeDisabled: true,
					editNodeDisabled: true,
					delNodeDisabled: true,
					children: [
						{
							name: "Node 1-2",
							id: 2,
							isLeaf: true,
							pid: 1
						}
					]
				},
				{
					name: "Node 2",
					id: 3,
					pid: 0,
					disabled: true
				},
				{
					name: "Node 3",
					id: 4,
					pid: 0
				}
			])
		}
	},
	methods: {
		onDel(node) {
			node.remove()
		},

		onChangeName(params) {},

		onAddNode(params) {},

		onClick(params) {},

		addNode() {
			var node = new TreeNode({ name: "new node", isLeaf: false })
			if (!this.data.children) this.data.children = []
			this.data.addChildren(node)
		},
		addLeaf() {
			var leaf = new TreeNode({ name: "new leaf", isLeaf: true })
			if (!this.data.children) this.data.children = []
			this.data.addChildren(leaf)
		},

		getNewTree() {
			var vm = this
			function _dfs(oldNode) {
				var newNode = {}

				for (var k in oldNode) {
					if (k !== "children" && k !== "parent") {
						newNode[k] = oldNode[k]
					}
				}

				if (oldNode.children && oldNode.children.length > 0) {
					newNode.children = []
					for (var i = 0, len = oldNode.children.length; i < len; i++) {
						newNode.children.push(_dfs(oldNode.children[i]))
					}
				}
				return newNode
			}

			vm.newTree = _dfs(vm.data)
		}
	}
}
</script>

<style scoped>
.main {
	width: 100%;
	display: flex;
}
.left {
	padding: 0px 10px 10px 10px;
	width: 30%;
}
.container {
	background-color: white;
	padding: 10px;
}
.right {
	padding: 0px 10px 10px 10px;
	width: 70%;
}
.fab {
	position: absolute;
	bottom: 20px;
	right: 20px;
}
</style>
